import { useCallback } from 'react';
import type { CalculatorFormatValue } from '@elfsight/configurator-contracts';
import { formatSuffixNumber } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import type { DecimalSeparatorType, ThousandsSeparatorType } from '../../types';

export function useCalculatorValueFormatter(format: CalculatorFormatValue) {
  const { thousandsSeparator, decimalSeparator } = useSettings();

  return useCallback(
    (value?: number | string) =>
      formatCalculatorValue({
        value: value,
        format,
        thousandsSeparator,
        decimalSeparator
      }),
    [format, thousandsSeparator, decimalSeparator]
  );
}

export function formatCalculatorValue({
  value,
  format,
  thousandsSeparator,
  decimalSeparator
}: {
  value?: number | string;
  format: CalculatorFormatValue;
  thousandsSeparator?: ThousandsSeparatorType;
  decimalSeparator?: DecimalSeparatorType;
}) {
  if (value && format?._mode === 'string') {
    return String(value);
  }

  if (typeof value === 'number') {
    return formatSuffixNumber(value, {
      prefix: format?.prefix,
      suffix: format?.suffix,
      minimumFractionDigits: format?.decimalPlaces,
      maximumFractionDigits: format?.decimalPlaces,
      thousandsSeparator,
      decimalSeparator
    });
  }

  return '—';
}
